module.exports = __webpack_public_path__ + "img/signal1.2b53834f.svg";